import { createUseStyles } from 'react-jss';

export default createUseStyles({
  hideCheckbox: {
    '& .ant-checkbox': {
      opacity: 0,
    },
    '& >span:last-of-type': {
      color: 'inherit',
    },
  },
});
